<template>
  <div class="page">
    <NavBar />
    
    <div class="profile-container">
      <div class="profile-card">
        <!-- Left Column -->
        <div class="profile-left">
          <!-- Profile Header -->
          <div class="profile-header">
            <img class="profile-avatar" src="./../assets/images/profile-pic.svg" alt="Profile Picture">
            <h1 class="profile-name">{{ name }}</h1>
            <div class="profile-rating">
              <img src="./../assets/images/stars-outline.svg" alt="Rating">
              <span class="reviews-count">0 reviews</span>
            </div>
          </div>

          <!-- Contact Information Grid -->
          <div class="info-grid">
            <div class="info-item">
              <div class="info-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
              <div class="info-content">
                <span class="info-label">Location</span>
                <span class="info-value">Los Angeles, CA</span>
              </div>
            </div>

            <div class="info-item">
              <div class="info-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </div>
              <div class="info-content">
                <span class="info-label">Phone</span>
                <span class="info-value">{{ contact }}</span>
              </div>
            </div>

            <div class="info-item">
              <div class="info-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <div class="info-content">
                <span class="info-label">Email</span>
                <span class="info-value">{{ email }}</span>
              </div>
            </div>

            <div class="info-item">
              <div class="info-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
                  <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
                </svg>
              </div>
              <div class="info-content">
                <span class="info-label">Education</span>
                <span class="info-value">{{ university }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column -->
        <div class="profile-right">
          <div>
            <!-- Bio Section -->
            <div class="bio-section">
              <h3 class="section-title">About</h3>
              <p class="bio-text">{{ bio || 'No bio available yet.' }}</p>
            </div>

            <!-- Expertise Tags -->
            <div class="expertise-section">
              <h3 class="section-title">Expertise</h3>
              <div class="tags-container">
                <SearchTag name="Standardized Tests" />
                <SearchTag name="College Admissions" />
                <SearchTag name="SAT" />
                <SearchTag name="ACT" />
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="action-buttons">
            <button @click="startChat" class="btn btn-primary">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
              Send Message
            </button>
            <router-link to="/pricing" class="btn btn-secondary">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M8 2v4M16 2v4M3 10h18"></path>
                <rect x="3" y="4" width="18" height="18" rx="2"></rect>
              </svg>
              Book Session
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const API_BASE = process?.env?.VUE_APP_API_BASE_URL ?? '/api';
import { useRouter } from "vue-router";
import axios from "axios";
import NavBar from "./../components/NavBar.vue";
import SearchTag from "./../components/SearchTag.vue";
import Auth from "../auth/auth.js";

export default {
  name: "UserProfileView",
  components: {
    NavBar,
    SearchTag
  },
  setup() {
    const router = useRouter();
    return { router };
  },
  data() {
    return {
      name: "",
      email: "",
      university: "",
      bio: "",
      contact: "",
      counselorUserId: null
    };
  },
  async mounted() {
    this.counselorUserId = this.$route.params.counselor_user_id;
    await this.fetchCounselorInfo();
  },
  methods: {
    async fetchCounselorInfo() {
      try {
        const response = await axios.get(
          `${API_BASE}/get_counselor_info?counselor_user_id=${this.$route.params.counselor_user_id}`
        );
        if (response.data && response.data.counselor) {
          this.name = response.data.counselor.name;
          this.email = response.data.counselor.email;
          this.university = response.data.counselor.university;
          this.bio = response.data.counselor.bio;
          this.contact = response.data.counselor.contact;
        }
      } catch (error) {
        console.error("Error fetching counselor info:", error);
      }
    },
    async startChat() {
      if (!this.isAuthenticated()) {
        this.router.push('/auth/login');
        return;
      }

      const studentId = Auth.getUserID();
      const recipientId = this.counselorUserId;

      if (!studentId || !recipientId) {
        console.error("Missing studentId or recipientId");
        return;
      }

      try {
        // Check if contact already exists
        const check = await fetch(`${API_BASE}/contacts/exists/${studentId}/${recipientId}`);
        const existsData = await check.json();

        // If not exists, create it
        if (!existsData.exists) {
          await fetch(`${API_BASE}/contacts/add`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              student_user_id: studentId,
              counselor_user_id: recipientId
            })
          });
        }

        // Navigate to messages page with recipient info
        this.router.push({
          name: "messages",
          query: {
            recipient_id: recipientId,
            name: this.name
          }
        });

      } catch (err) {
        console.error("Error in startChat:", err);
      }
    },
    isAuthenticated() {
      return Auth.isAuthenticated();
    }
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background-color: #f5f7fa;
  padding-top: 80px;
}

.profile-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 1.5rem 1rem;
  display: flex;
  align-items: center;
  min-height: calc(100vh - 80px);
}

.profile-card {
  width: 100%;
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto 1fr;
  gap: 2rem;
}

.profile-header {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.profile-avatar {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  margin-bottom: 0.75rem;
  border: 3px solid #3867ae;
}

.profile-name {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.profile-left {
  display: flex;
  flex-direction: column;
}

.profile-right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.profile-rating {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}

.profile-rating img {
  height: 18px;
}

.reviews-count {
  font-size: 0.875rem;
  color: #6b7280;
}

/* Info Grid */
.info-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.875rem;
  margin-bottom: 0;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem;
  background: #f9fafb;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.info-item:hover {
  background: #f3f4f6;
  transform: translateX(2px);
}

.info-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #e3eaf5;
  border: 2px solid #2d5290;
  border-radius: 8px;
  color: #2d5290;
  flex-shrink: 0;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.info-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.info-value {
  font-size: 0.875rem;
  color: #1f2937;
  font-weight: 500;
  word-break: break-word;
}

/* Sections */
.bio-section,
.expertise-section {
  margin-bottom: 1.25rem;
  padding: 1.25rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.section-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.75rem 0;
}

.bio-text {
  font-size: 0.875rem;
  line-height: 1.6;
  color: #4b5563;
  margin: 0;
  padding: 0.875rem;
  background: #f9fafb;
  border-radius: 10px;
  border-left: 3px solid #3867ae;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.625rem;
}


.tags-container :deep(.search-tag) {
  background: linear-gradient(145deg, #4a7bc8 0%, #3867ae 100%);
  color: white;
  padding: 0.5rem 1.125rem;
  border-radius: 30px;
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  box-shadow: 0 4px 10px rgba(56, 103, 174, 0.3), 
              inset 0 1px 0 rgba(255, 255, 255, 0.2);
  transition: all 0.2s ease;
  position: relative;
}

.tags-container :deep(.search-tag::before) {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 30px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
  pointer-events: none;
}

.tags-container :deep(.search-tag:hover) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(56, 103, 174, 0.4),
              inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 0.75rem;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  max-width: 200px;
}

.btn svg {
  background: #e3eaf5;
  border: 2px solid #2d5290;
  border-radius: 6px;
  padding: 4px;
  width: 24px;
  height: 24px;
  color: #2d5290;
  flex-shrink: 0;
}

.btn:active {
  transform: scale(0.98);
}

.btn-primary {
  background: #3867ae;
  color: white;
}

.btn-primary:hover {
  background: #2d5290;
  box-shadow: 0 4px 10px rgba(56, 103, 174, 0.3);
  transform: translateY(-1px);
}

.btn-secondary {
  background: white;
  color: #3867ae;
  border: 2px solid #3867ae;
}

.btn-secondary:hover {
  background: #f0f4fa;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(56, 103, 174, 0.2);
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .page {
    padding-top: 70px;
  }

  .profile-container {
    padding: 1rem 0.5rem;
    min-height: auto;
  }

  .profile-card {
    padding: 1.5rem;
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .profile-avatar {
    width: 80px;
    height: 80px;
  }

  .profile-name {
    font-size: 1.5rem;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn {
    max-width: 100%;
  }
}
</style>